export default {
  methods: {
    postToFeed() {
      let test_img = this.test.img;
      // let desc = this.test.desc
      let desc = "გაიარე ეროვნულების ტესტირება abituri.ge-ზე";
      let total = this.total + 1;
      let title = `${this.test.name}, ${this.score}/${total} ქულა`;
      FB.ui({
        method: "share_open_graph",
        action_type: "og.shares",
        hashtag: "#abiturige",
        quote: "A Year From Now You Will Wish You Had Started Today",
        href: "https://www.abituri.ge/",
        action_properties: JSON.stringify({
          object: {
            "og:url": "https://www.abituri.ge/",
            "og:title": title,
            "og:description": desc,
            "og:og:image:width": "400",
            "og:image:height": "400",
            "og:image": "https://www.abituri.ge/" + test_img,
          },
        }),
      });
    },
  },
};
